import { createIcon } from "@chakra-ui/react";

export const Clock = createIcon({
  displayName: "Clock",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#eoxrtrgd5a)">
      <path
        fill="currentColor"
        d="M21.75 12a9.75 9.75 0 1 1-19.5 0 9.75 9.75 0 0 1 19.5 0zM0 12a12 12 0 1 0 24 0 12 12 0 0 0-24 0zm10.875-6.375V12c0 .375.188.727.502.938l4.5 3a1.122 1.122 0 0 0 1.56-.315 1.121 1.121 0 0 0-.314-1.56L13.125 11.4V5.625c0-.623-.502-1.125-1.125-1.125s-1.125.502-1.125 1.125z"
      />
    </g>,
    <defs>
      <clipPath id="eoxrtrgd5a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "A clock icon"
  }
});

export default Clock;
